<div class="wrap">
    <table class="playerRankingTable">
        <thead>
        <tr [class.scroll]="isScrolling">
            <th>{{ 'rank' | translate }}</th>
            <th>{{ 'nickname' | translate }}</th>
            <th *ngIf="!isIndiaCountry">{{ 'flag' | translate }}</th>
            <th>{{ (isBountyKOPromotion ? 'KOs' : 'points') | translate }}</th>
            <th *ngIf="prizeVisibility">{{ 'prize' | translate }}</th>
        </tr>
        </thead>
        <tbody class="playerRankingBody">
        <tr *ngFor="let player of rankingList; let i = index" [class.myRank]="!focusFirstPlayer ? checkSameUser(player) : i === 0" #ranks>
            <td>{{ player.rank || '-' }}</td>
            <td><span class="nickname">{{ player.nickname }}</span></td>
            <td class="flag" *ngIf="!isIndiaCountry">
                <span class="country" [attr.data-title]="getCountry(player.countryId)">
                    <img src="/assets/static/leaderboard/img/country/{{player.displayCountryId}}.png">
                </span>
            </td>
            <td>{{ player.point | number: (isBountyKOPromotion ? '1.0-0' : '1.2-2') }}</td>
            <td class="prize" *ngIf="prizeVisibility" [ngClass]="{ 'custom': isWsopPrizeCustom }">
                <ng-template [ngIf]="!isChase" [ngIfElse]="chasePrize">
                    <ng-template [ngIf]="!!player.prize" [ngIfElse]="nullPrize">
                        <ng-template [ngIf]="!!player.prize.value" [ngIfElse]="customPrize">
                            <span *ngIf="!isWsopPrizeCustom">
                                {{ player.prize.value | cash : player.prize.currencyId:'symbol-narrow':'1.2-2': null: onlyCoin: hideSymbol: hideCustomSymbol }}
                            </span>
                            <span *ngIf="isWsopPrizeCustom">
                                {{ player.prize.value | cash : player.prize.currencyId:'symbol-narrow':'1.2-2': null: onlyCoin }}
                                <span class="prizeItem"><br>{{ wsopPrizeCustom(player.prize) }}</span>
                            </span>
                        </ng-template>
                        <ng-template #customPrize>{{ player.prize.description || '-' }}</ng-template>
                    </ng-template>
                    <ng-template #nullPrize>-</ng-template>
                </ng-template>
                <ng-template #chasePrize>
                    <ng-template [ngIf]="!!player.prize" [ngIfElse]="nullPrize">
                        <ng-template [ngIf]="!!player.prizePaid.value" [ngIfElse]="customPrize">
                            {{ player.prizePaid.value | cash : player.prizePaid.currencyId:'symbol-narrow':'1.2-2': null: onlyCoin: hideSymbol: hideCustomSymbol }}
                        </ng-template>
                        <ng-template #customPrize>{{ !!player.prize.description ? 'Custom' : '-' }}</ng-template>
                    </ng-template>
                    <ng-template #nullPrize>-</ng-template>
                </ng-template>
            </td>
        </tr>
        <tr *ngIf="!isMaintenance && (!rankingList || rankingList.length <= 0)">
            <td class="maintenance">{{ 'dataEmpty' | translate }}</td>
        </tr>
        <tr *ngIf="isMaintenance">
            <td colspan="5" class="maintenance">
                <p [innerHTML]="'maintenance_desc01' | translate">Currently under maintenance.</p>
                <p [innerHTML]="'maintenance_desc02' | translate">Please check back shortly.</p>
            </td>
        </tr>
        </tbody>
    </table>

    <section class="prizePoolSection" *ngIf="isChase">
        <h1>{{ 'prizePool' | translate }}</h1>
        <table class="playerRankingTable prizeStructureTable">
            <thead>
            <tr>
                <th>{{ 'level' | translate }}</th>
                <th>{{ 'requiredPoints' | translate }}</th>
                <th>{{ 'winners' | translate }}/{{ 'maxWinners' | translate }}</th>
                <th *ngIf="prizeVisibility">{{ 'prize' | translate }}</th>
            </tr>
            </thead>
            <tbody class="prizeStructureBody">
            <tr *ngFor="let list of prizePoolList" [class.running]="list.isRunning" #runningPrizeLevel>
                <td>{{ list.level | number }}</td>
                <td>{{ list.pointMin | number }}</td>
                <td><span>{{ list.winners | number }}</span>/<span>{{ list.maxWinners | number }}</span></td>
                <td *ngIf="prizeVisibility">
                    <span *ngIf="!list.isCustom">{{ !!list.prize ? (list.prize.value / (list.maxWinners || 0) | cash : list.prize.currencyId || 'USD' :'symbol-narrow':'1.2-2': null: onlyCoin: hideSymbol: hideCustomSymbol) : '-' }}</span>
                    <span *ngIf="list.isCustom">{{ list.description || '-' }}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </section>
</div>

<div class="loadingArea" *ngIf="progress"></div>
